import React from 'react';
import {
   FormControl,
   FormLabel,
   FormGroup,
   FormControlLabel,
   RadioGroup,
   Radio,
   ToggleButton,
   ToggleButtonGroup,
   Box
} from '@mui/material';
import { useQuote } from '../../lib/contexts/QuoteContext';

const extendedTransportOptions = [
   "20ft Container", "40ft Container", "40ft HC (High Cube) Container", "45ft HC (High Cube) Container",
   "20ft Reefer Container", "40ft Reefer Container", "40ft HC Reefer Container", "45ft HC Reefer Container",
   "20ft Open Top Container", "40ft Open Top Container", "20ft Flat Rack", "40ft Flat Rack",
   "20ft Tank Container", "40ft Tank Container", "20ft Bulk Container", "40ft Bulk Bulk Container",
   "20ft Ventilated Container", "40ft Ventilated Container", "20ft Platform", "40ft Platform",
   "20ft Collapsible Flat Rack", "40ft Collapsible Flat Rack", "20ft Garmentainer", "40ft Garmentainer",
   "Enclosed Auto Transport", "Open Auto Transport", "Specialized Boat Transport",
   "Hazmat Certified Transport", "Temperature Controlled Transport", "Oversized Load Transport"
].map(value => ({
   value,
   label: value
      .replace(/([A-Z])/g, ' $1')
      .trim()
      .replace(/ft/g, ' ft')
      .replace(/HC/g, 'HC (High Cube)')
}));

const TypeOfTransport = ({ useExtended = false }) => {
   const {
      transportType,
      setTransportType,
      vehicleCondition,
      setVehicleCondition
   } = useQuote();
   
   return (
      <Box
         component="section"
         sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 2,
            alignItems: 'flex-start'
         }}
      >
         {/* Column 1: Type of Transport */}
         <FormControl component="fieldset" fullWidth size="small">
            <FormLabel component="legend" sx={{ fontSize: '0.875rem', mb: 1 }}>
               Type of Transport
            </FormLabel>
            
            {useExtended ? (
               <FormGroup
                  sx={{ maxHeight: 200, overflowY: 'auto', '& .MuiFormControlLabel-root': { py: 0.5 } }}
               >
                  <RadioGroup
                     value={transportType}
                     onChange={e => setTransportType(e.target.value)}
                  >
                     {extendedTransportOptions.map(o => (
                        <FormControlLabel
                           key={o.value}
                           value={o.value}
                           control={<Radio size="small" />}
                           label={o.label}
                        />
                     ))}
                  </RadioGroup>
               </FormGroup>
            ) : (
               <ToggleButtonGroup
                  exclusive
                  size="small"
                  value={transportType}
                  onChange={(_, newType) => {
                     if (newType !== null) {
                        setTransportType(newType);
                     }
                  }}
                  aria-label="type of transport"
                  sx={{ mt: 1 }}
               >
                  <ToggleButton value="enclosed" aria-label="enclosed">
                     Enclosed
                  </ToggleButton>
                  <ToggleButton value="open" aria-label="open">
                     Open
                  </ToggleButton>
               </ToggleButtonGroup>
            )}
         </FormControl>
         
         {/* Column 2: Is Operable? */}
         <FormControl component="fieldset" fullWidth size="small">
            <FormLabel component="legend" sx={{ fontSize: '0.875rem', mb: 1 }}>
               Is Operable?
            </FormLabel>
            <ToggleButtonGroup
               exclusive
               size="small"
               value={vehicleCondition ? 'true' : 'false'}
               onChange={(_, newVal) => {
                  if (newVal !== null) {
                     setVehicleCondition(newVal === 'true');
                  }
               }}
               aria-label="is operable"
               sx={{ mt: 1 }}
            >
               <ToggleButton value="true" aria-label="operable-yes">
                  Yes
               </ToggleButton>
               <ToggleButton value="false" aria-label="operable-no">
                  No
               </ToggleButton>
            </ToggleButtonGroup>
         </FormControl>
      </Box>
   );
};

export default TypeOfTransport;
